import { Box, Card, styled } from "@mui/material"

export const CustomCard = styled(Card)(({ theme }) => ({
    maxWidth: '540px',
    minWidth: '320px',
    minHeight: '300px',
    boxShadow: '0px -3px 15px rgba(54, 60, 69, 0.2)',
    margin: '0 auto',

    '& .boiler-buttons-box': {
        marginTop: 'auto', 
        transition: 'margin-top 0.3s ease', 

        '@media (max-width: 1200px)': {
            marginTop: '20px', 
        },

        '@media (max-width: 1050px)': {
            marginTop: '30px', 
        },

        '@media (max-width: 1000px)': {
            marginTop: '30px', 
        },
        '@media (min-width: 500px)': {
            marginBottom: '10px',
        },
        '@media (max-width: 519px)': {
            marginTop: '0px',
            paddingTop: '10px',
            display: 'flex',
            justifyContent: 'center',
        },
    },

    [theme.breakpoints.up('xs')]: {
        width: '100%',
    },  
    [theme.breakpoints.between('sm', 's')]: {
        width: '320px',
    },
    [theme.breakpoints.up('xl')]: {
        minWidth: '100%',
    }
}))

export const CustomContent= styled(Box)(({ theme }) => ({
    padding: '16px',
    [theme.breakpoints.up('xs')]: {
        display: 'block',
    },
    [theme.breakpoints.up('s')]: {
        display: 'flex',
    },
    '& .chart-box-wrapper': {
        marginTop: '16px', 
        
        '@media (max-width: 519px)': {
            marginTop: '56px', 
        },

        '@media (max-width: 400px)': {
            marginTop: '70px', 
        }
    }
}))

export const TextContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    maxWidth: '350px',
    minWidth: '200px',
    [theme.breakpoints.up('xs')]: {
        maxHeight: '200px',
    },
    [theme.breakpoints.up('s')]: {
        maxHeight: '150px',
    },

}))

export const ChartBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    [theme.breakpoints.up('xs')]: {
        left: '15%'
    },
    [theme.breakpoints.between('s', 'xl')]: {
        left: 0,
    },
    [theme.breakpoints.up('xl')]: {
        left: 0,
    }
}))

export const ChartText = styled(Box)(({ theme }) => ({
    position: 'absolute',
    zIndex: 'tooltip',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('xs')]: {
        top: '40%',
        left: '20%',
    },
    [theme.breakpoints.between('s', 'xl')]: {
        top: '40%',
        left: '30%',
    },
    [theme.breakpoints.up('xl')]: {
        left: '30%'
    }
}))

export const CardButtons = styled(Box)(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.up('xs')]: {
        justifyContent: 'space-around',
        padding: '0 16px 16px 16px'
    },
    [theme.breakpoints.between('s', 'lg')]: {
        width: '50%',
        justifyContent: 'flex-start',
        padding: '0 16px'
    },
    [theme.breakpoints.up('lg')]: {
        width: '50%',
        justifyContent: 'flex-start',
        // padding: '0 16px'
    }
}))

/**
 * Форматирует число до целого значения
 * @param {string|number|null|undefined} value - значение для форматирования
 * @param {string} defaultValue - значение по умолчанию, если value null/undefined
 * @returns {string} - отформатированное число или defaultValue
 */
export const formatToInteger = (value, defaultValue = "-") => {
    if (value == null) return defaultValue;
    return parseFloat(value).toFixed(0);
};

/**
 * Форматирует дробное число (например, площадь)
 * @param {string|number|null|undefined} value
 * @param {number} decimals
 * @param {string} defaultValue
 * @returns {string}
 */
export const formatArea = (value, decimals = 1, defaultValue = "-") => {
    if (value == null || value === "") return defaultValue;
    const num = parseFloat(value);
    return isNaN(num) ? defaultValue : num.toFixed(decimals);
};

/**
 * Рассчитывает долю в котле в процентах
 * @param {string|number} ownerArea
 * @param {string|number} boilerArea
 * @returns {string}
 */
export const getBoilerShare = (ownerArea, boilerArea) => {
    const owner = parseFloat(ownerArea);
    const boiler = parseFloat(boilerArea);
    if (isNaN(owner) || isNaN(boiler) || boiler <= 0) return "0";
    return ((owner / boiler) * 100).toFixed(1);
};

/**
 * Группирует бойлерные апартаменты по программам и отделяет обычные
 * @param {Array} aparts - исходный массив апартаментов
 * @returns {Object} { boilerGroups: {id: [aparts]}, regularAparts: [] }
 */
export const getGroupedAparts = (aparts) => {
    if (!aparts) return { boilerGroups: {}, regularAparts: [] };

    const result = aparts.reduce((acc, item) => {
        if (item.isBoiler) {
            const programKey = `${item.RentalProgramID || '0'}_${item.boilerName || 'unknown'}`;

            if (!acc.boilerGroups[programKey]) acc.boilerGroups[programKey] = [];
            acc.boilerGroups[programKey].push(item);
        } else {
            acc.regularAparts.push(item);
        }
        return acc;
    }, { boilerGroups: {}, regularAparts: [] });

    return result;
};

/**
 * Форматирует процент для котлового метода (умножает на 100 и округляет)
 * Форматирует процент для обычного апарта (приходит "0": превращаем в "0.0" и отрезаем то, что после запятой на всякий случай)
 * @param {string|number|null|undefined} value - значение в формате 0-1
 * @param {string} defaultValue - значение по умолчанию
 * @returns {string} - отформатированный процент
 */
export const formatPercent = (isBoiler, value, defaultValue = "0.0") => {
    if (value == null) return defaultValue;
    if (isNaN(value)) return defaultValue;
    if (isBoiler) return (parseFloat(value) * 100).toFixed(1);
    else return (parseFloat(value)).toFixed(1);
};

/**
 * Обрезает строку до указанного лимита и добавляет многоточие
 * @param {string} text - Исходная строка
 * @param {number} limit - Максимальное количество символов (по умолчанию 49)
 * @returns {string}
 */
export const truncateBySymbols = (text, limit = 49) => {
    if (!text) return "";
    return text.length > limit 
        ? text.substring(0, limit).trim() + "..." 
        : text;
};